var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container pt-4"},[_c('BackButton',{attrs:{"variant-name":"success","extra-style":"text-dark"}}),_vm._m(0),_c('SectionTeamVue')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"mt-4"},[_c('h2',[_vm._v("Meet the Team")])])
}]

export { render, staticRenderFns }